export const DEAR_AUTO_APPROVAL_LEARN_MORE_LINK =
    'https://support.approvalmax.com/portal/en/kb/articles/how-do-i-set-up-the-pull-from-dear-step-for-purchase-orders';

export const DEAR_NAVIGATION_ADVANCED_FEATURES = [];
